<template>

    <!-- new component -->
    <div class="targetTabContainer" style="margin-top: 10px;">
        <div style="
        white-space: normal;
        width: 100%;
        margin-left: 20px;
        margin-right: 20px;
        display: inline-flex;
        justify-content: center;
        margin: 8px;
        background: #fff;
        max-width: 391px;
        flex-direction: column;
    " >
            <div class="infoBox">
                <!-- <div>
                    <h3 class="subTitle">מגמת שינוי ברבעון הקודם</h3>
                    <div class="trendChange" v-if="getPriceDifferencePercentage != null">
                        <img
                            v-if="getPriceDifferencePercentage > 0"
                            src="/images/arrowGreen.svg"
                            class="arrowIcon"
                            alt=""
                            /><img
                            v-if="getPriceDifferencePercentage < 0"
                            src="/images/arrowRed.svg"
                            class="arrowIcon"
                            alt=""
                            />
                            <span class="text price-value">{{ getPriceDifferencePercentage }}%</span>
                            <span class="text" > {{ upOrDown }}</span>
                            
                    </div>
                    <div class="trendChange" v-else>
                        <span class="text">לא ידוע</span>
                    </div>
                </div> -->
                <div>
                    <div class="lastYearHeader" style="margin-bottom: 5px; display: flex; font-weight: bold;">
                        <div class="iconCircle">
                            <svg
                                width="16px"
                                height="16px"
                                viewBox="0 0 16 16"
                                version="1.1"
                                class="icon tooltipIcon"
                                >
                                <g
                                    id="home-16"
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                    >
                                    <path
                                        d="M12.5,4 L13,10.5 L7.3516287,11 L3.26829537,7.5 L7.3516287,4 L12.5,4 Z"
                                        id="Rectangle"
                                        stroke="#ffffff"
                                        transform="translate(8.000000, 7.500000) rotate(-270.000000) translate(-8.000000, -7.500000) "
                                        ></path>
                                    <path
                                        d="M12.2426407,3.75735931 L11.6208918,10.5965968 C11.5714457,11.1405042 11.1405042,11.5714457 10.5965968,11.6208918 L3.75735931,12.2426407 L3.75735931,12.2426407"
                                        id="Rectangle"
                                        stroke="#ffffff"
                                        transform="translate(8.000000, 8.000000) rotate(-135.000000) translate(-8.000000, -8.000000) "
                                        ></path>
                                </g>
                            </svg>
                        </div>
                        <h3 class="subTitle">
                            מחיר  {{ pageType }} חציוני שנתי
                        </h3>
                    </div>
                    <p>
                        <span class="text" style="font-size: 1em;">
                            משוקלל כלל החדרים:
                        </span>
                        <span class="text" style="font-size: 1em;">
                            {{ priceDisplay( $store.state.lastYearAvgPrice) }} 
                        </span>
                    </p>
                    <p>
                        <span class="text" style="font-size: 1em;">
                            3 חדרים:
                        </span>
                        <span class="text" style="font-size: 1em;">
                            {{ priceDisplay( $store.state.lastYearAvgPrice_3) }} 
                        </span>
                    </p>
                    <p>
                        <span class="text" style="font-size: 1em;">
                            4 חדרים:
                        </span>
                        <span class="text" style="font-size: 1em;">
                            {{ priceDisplay( $store.state.lastYearAvgPrice_4) }} 
                        </span>
                    </p>
                    <p>
                        <span class="text" style="font-size: 1em;">
                            5 חדרים:
                        </span>
                        <span class="text" style="font-size: 1em;">
                            {{ priceDisplay( $store.state.lastYearAvgPrice_5) }} 
                        </span>
                    </p>
                </div>
            </div>
            <div id="tooltip" class="infoBox"></div>

            <div class="infoBox" style="border-color: transparent; margin: 0px; padding-right: 0px;">
                <span class="text" style="font-size: 1.2em;">הנתונים מבוססים על ניתוחי מאגרי מידע שונים, ייתכנו אי דיוקים </span>
            </div>
        </div>
        <div class="graphContainer">
            <div
                role="region"
                style="position: relative; cursor: default"
                >
                <div style="display: flex; flex-direction: column;">
                    <div class="navTabs nav" role="tablist">

                        <div
                            v-for="tab in tabs"
                            :key="tab.key"
                            :class="{
                            'nav-item': true,
                            active:
                            selectedTab === tab.key ||
                            (selectedTab === undefined && tab.key === 'all'),
                            }"
                            >
                            <a
                                href="#"
                                role="tab"
                                :id="`roomTab_${tab.key}`"   
                                :data-rb-event-key="tab.key"
                                :aria-selected="selectedTab === tab.key"
                                class="roomTab nav-link"
                                @click.prevent="selectTab(tab)"
                                >
                            {{ tab.label }}
                            </a>
                        </div>
                    </div>
                    <GraphComponent ref="graph_component" style="margin-top: 20px;">
                    </GraphComponent>
                </div>
                <div
                    class="recharts-legend-wrapper"
                    style="position: absolute; height: auto; right: 0px"
                    >
                </div>
                <div
                    tabindex="-1"
                    role="dialog"
                    class="recharts-tooltip-wrapper recharts-tooltip-wrapper-right recharts-tooltip-wrapper-bottom"
                    style="
                    pointer-events: none;
                    visibility: hidden;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    transform: translate(150px, 10px);
                    "
                    >
                    <div class="graphBuble">
                        <p class="plainText">לא קיימות עסקאות בשנה זו</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
   



</template>


<script>
import GraphComponent from "./GraphComponent";

export default {
    name: "TargetContainer",
    components: {
        GraphComponent,
    },
    data() {
        return {
       
            tabs: [
				{ key: "all", label: "כל החדרים" },
				{ key: "3", label: "3 חדרים" },
				{ key: "4", label: "4 חדרים" },
				{ key: "5", label: "5 חדרים" },
			],
			selectedTab: "all",

        };
    },
    mounted() {
        this.$nextTick(() => {
            this.selectTab(this.tabs[0]);
        });
    },
    methods: { 
        createChart() {
            // console.group('Chart Creation Process');
            // console.log('Current Tab:', this.currentTab);
            // console.log('Graph Data Length:', this.graphData.length);
            // console.log('All Data:', this.allData);
            
            // Rest of the existing createChart method
            
            console.groupEnd();
        },  
        priceDisplay(valueDisplay) {
            var value = "לא ידוע";
            if (valueDisplay >= 1000000) {
                value = (valueDisplay / 1000000).toFixed(2) + " מ' ₪";
            } else if (valueDisplay >= 1000) {
                value = Number(valueDisplay.toFixed(0)).toLocaleString() + " ₪";
            }
            return value;
        },  
        selectTab(tab) {
            // Ensure store and graph component are in sync
            this.$store.state.selectedTab = tab.key;
            this.tabs.forEach((t) => {
				const element = document.querySelector(
					`[data-rb-event-key="${t.key}"]`,
				);
				if (element) {
					element.classList.remove("active");
				}
			});
            this.selectedTab = tab.key;
            const selectedElement = document.querySelector(
				`[data-rb-event-key="${tab.key}"]`,
			);
			if (selectedElement) {
				selectedElement.classList.add("active");
			}

            // Use nextTick to ensure DOM is updated
            this.$nextTick(() => {
            if (this.$refs.graph_component) {
                // Explicitly update graph component
                this.$refs.graph_component.currentTab = tab.key;
                this.$refs.graph_component.updateGraphData();
                this.$refs.graph_component.updateChart();
            }
            });
        }
    },
    // watch: {
    //     selectedTab(a,b){
    //         console.log(a,b);
    //     }

    // },
    computed: {
        upOrDown() {
			if (this.getPriceDifferencePercentage < 0) {
				return "ירידת מחירים";
			} else {
				return "עליית מחירים";
			}
		},
        getPriceDifferencePercentage() {
			if (this.selectedTab == "all") {
				return this.$store.state.priceDifferencePercentage;
			} else if (this.selectedTab == "3") {
				return this.$store.state.priceDifferencePercentage_3;
			} else if (this.selectedTab == "4") {
				return this.$store.state.priceDifferencePercentage_4;
			} else if (this.selectedTab == "5") {
				return this.$store.state.priceDifferencePercentage_5;
			} else {
				return null;
			}
		},
        getLastYearAvgPrice() {
			if (this.selectedTab == "all") {
				if (this.$store.state.lastYearAvgPrice == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice.toLocaleString("he-IL");
			} else if (this.selectedTab == "3") {
				if (this.$store.state.lastYearAvgPrice_3 == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice_3.toLocaleString("he-IL");
			} else if (this.selectedTab == "4") {
				if (this.$store.state.lastYearAvgPrice_4 == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice_4.toLocaleString("he-IL");
			} else if (this.selectedTab == "5") {
				if (this.$store.state.lastYearAvgPrice_5 == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice_5.toLocaleString("he-IL");
			} else {
				return null;
			}
		},
        pageType(){
            // get page param from url route

            var types  = {
                "deals": "קנייה",
                "rent": "השכרה",
            }
            return types[this.$route.query.page];
        }
    }
};

</script>


<style >


.targetTabContainer h3 {
    font-size: 1.7em;
    margin-bottom: 5px;
  }
  
.targetTabContainer p {
    font-size: 1.6em;
    margin-bottom: 5px;
  }

  .price-value {
    unicode-bidi: bidi-override;
    direction: ltr;
}
</style>


